import escapeStringRegexp from 'escape-string-regexp';

export const addSubjectToMailLinks = ({
  html,
  address,
  subject
}: {
  html: string | null;
  address: string;
  subject: string;
}) => {
  if (!html) return '';

  const regexp = new RegExp(`<a(.*?)href="mailto:${escapeStringRegexp(address)}"(.*?)>`, 'g');

  return html.replace(regexp, `<a$1href="mailto:${address}?subject=${subject}"$2>`);
};
